import React, { useRef, useState } from 'react';
import Icon from '@amzn/meridian/icon';
import Button from '@amzn/meridian/button';
import undoTokens from '@amzn/meridian-tokens/base/icon/undo';
import Link from '@amzn/meridian/link';
import Popover, { PopoverHeader } from '@amzn/meridian/popover';
import Column from '@amzn/meridian/column';
/**
 * This component displays a popover UI for overriding volume values
 * @param {*} param0
 * @returns {JSX.Element} - The rendered OverridePopover component
 */
const OverridePopover = ({
  isEditable,
  isRevertible,
  onRevert,
  popoverContent,
  disabled,
  onSubmit,
  displayChargeValue
}) => {
  const linkRef = useRef();
  const [open, setOpen] = useState(false);

  if (!isEditable) return displayChargeValue;
  return (
    <React.Fragment>
      {isRevertible && (
        <Button type="link" onClick={onRevert}>
          <Icon tokens={undoTokens} />
        </Button>
      )}

      <Link type="secondary" onClick={() => setOpen(true)} ref={linkRef}>
        {displayChargeValue}
      </Link>

      <Popover anchorNode={linkRef.current} open={open} onClose={() => setOpen(false)} position="bottom">
        <PopoverHeader closeLabel="Close">Provide an override</PopoverHeader>
        <Column>
          {popoverContent}
          <Button
            disabled={disabled}
            onClick={() => {
              onSubmit();
              setOpen(false);
            }}>
            Submit Override
          </Button>
        </Column>
      </Popover>
    </React.Fragment>
  );
};

export default OverridePopover;
